<template>
  <addMatter/>
</template>

<script>
import addMatter from "./addMatter";
export default {
  name: "editMatter",
  components:{
    addMatter
  }
}
</script>
